import React from 'react';
import './Modal.css';

export default function Modal({ children, isOpen, onClose, customStyle }) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal" style={customStyle}>
        <button className="modal-close" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
}
